export default function PenIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width ? width : "23"}
      height={height ? height : "23"}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.936 5.38099L6.62417 11.6928C6.53483 11.7828 6.47288 11.8963 6.44745 12.0202L5.47776 16.6404C5.43276 16.855 5.49862 17.078 5.65317 17.2332C5.80707 17.389 6.02944 17.4569 6.24399 17.4138L10.902 16.4826C11.0286 16.4572 11.1446 16.3952 11.2353 16.3039L17.5471 9.9921L12.936 5.38099ZM13.8581 4.4589L18.4692 9.07001L19.6384 7.90142C20.912 6.62783 20.912 4.56324 19.6384 3.28966C19.0268 2.67863 18.1979 2.33496 17.3332 2.33496C16.4679 2.33496 15.639 2.67863 15.0273 3.28966L13.8581 4.4589Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.31216 20.2181H18.9629C19.5029 20.2181 19.9411 19.7798 19.9411 19.2399C19.9411 18.6999 19.5029 18.2617 18.9629 18.2617H3.31216C2.77221 18.2617 2.33398 18.6999 2.33398 19.2399C2.33398 19.7798 2.77221 20.2181 3.31216 20.2181Z"
        fill="currentColor"
      />
    </svg>
  );
}
